export class HttpServerInjectable {
}
//# sourceMappingURL=http-server.js.map